export default "__VITE_ASSET__85a046d0__"